/* @flow */
import { Request } from "shared/src/services/Requests";

const ContentRequestBuilder = new Request.Builder("explore", "content");
const ContentSearchRequestBuilder = new Request.Builder("searchdiscover", "contentsearch", true);
import { Footer } from "../datatypes/Footer";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";

const service = {
    getContent(country: string, locale: string) {
        const template = "/content/snippets/{country}/{locale}";
        return ContentRequestBuilder.path(template, { country: country, locale: locale }).get();
    },

    getCookieLawDisclaimer(country: string) {
        const template = "/sitecore/cookielaw/{country}";
        return ContentRequestBuilder.path(template, { country: country }).get();
    },

    getSitecoreStoreInformation(country: string, locale: string) {
        const template = "/sitecore/storeinformation/{country}/{locale}";
        return ContentRequestBuilder.path(template, { country: country, locale: locale }).get();
    },

    getSitecoreFooter(country: string, locale: string): Promise<Footer> {
        const template = "/sitecore/footer/{country}/{locale}";
        return ContentRequestBuilder.path(template, { country, locale }).get();
    },

    getSearchContent(
        country: string,
        locale: string | undefined | null,
        query: string | undefined | null,
        rows: number | undefined | null,
        page: number | undefined | null
    ) {
        if (CountryUtil.getOptionalConfig()?.useNewContentSearch) {
            const template = "/countries/{country}/search";
            // Needed because the old contentsearch service had 1 based pages
            const zeroBasedPage = Math.max((page || 1) - 1, 0);
            const queryParams = { query, rows, page: zeroBasedPage, locale };
            return ContentSearchRequestBuilder.path(template, { country }).query(queryParams).get();
        }
        const template = "/sitecore/country/{country}/search";
        const queryParams = { query, rows, page, locale };
        return ContentRequestBuilder.path(template, { country }).query(queryParams).get();
    }
};

export default service;

export const { getContent, getCookieLawDisclaimer, getSitecoreStoreInformation, getSitecoreFooter, getSearchContent } =
    service;
